import { defineMessages } from 'react-intl-next';

export default defineMessages({
	hubStudioLoadingSpinnerLabel: {
		id: 'hub-home.loading-spinner-label',
		defaultMessage: 'Loading hub',
		description: 'Label for the hub studio loading spinner',
	},
});
